export enum EntityTypeEnum {
  Individual = 0,
  Corporate = 1,
  Numbered = 2,
  Joint = 3,
}
